module.exports = __webpack_public_path__ + "static/Randy-Stickles-11d2eb5fc3ba590c9ac7b3877d6f76e2.jpg";